import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { Tablev2Component } from '../tablev2/tablev2.component';

@Component({
  selector: 'app-payment-gateway-log',
  templateUrl: './payment-gateway-log.component.html',
  styleUrls: ['./payment-gateway-log.component.scss']
})
export class PaymentGatewayLogComponent {

  public data:any = {match: "exact"};
  public load:any = false;
  public items:any = [];
  public games:any = []
  public providers:any = [];
  public company_uuid:string;
  @ViewChild("table", { static: false }) tb: Tablev2Component;

  constructor(private http: HttpService, private cdr : ChangeDetectorRef) { 
    this.http.getSelectedCompany().subscribe(val => {
      this.company_uuid = val;
    }); 
    this.init()
  }

  async init() {
    let date = new Date();
    const today = this.formatDate(date);
    this.data.date_from = today;
    this.data.date_to = today;

    let providers:any = await this.http.post("/admin/payment-gateway/provider/get");
    this.providers = providers.providers || [];
  }

  formatDate(date: Date) {
    return date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2);
  }

  async filter() {

    const setting = 
        { post: {url: "/admin/payment-gateway/log", data: {uuid: this.company_uuid, f: this.data}},
          disabled_pagenat: false,
          fields: [
            {label: 'No', type: 'index'}, 
            {label: 'Type', type: 'string', key: 'type'}, 
            {label: 'Currency', type: 'string', key: 'currency'}, 
            {label: 'Player Code', type: 'string', key: 'player_code'}, 
            {label: 'Gateway', type: 'string', key: 'gateway_name', footer_label: 'Total'}, 
            {label: 'Amount', type: 'price', key: 'amount', footer_key: 'amount', footer_type: 'price'}, 
            {label: 'Reference ID', type: 'string', key: 'reference'}, 
            {label: 'Status', type: 'string', key: 'status'}, 
            {label: 'Update Payment', type: 'update-payment', action: async (data) => {
              data.is_loading = true;
              let y = await this.http.post('/admin/payment-gateway/log/update', data)
              this.tb.reload();
              data.is_loading = false;
            }}, 
            {label: 'Updated On', type: 'datetime', key: 'update_on'},
            {label: 'Create On', type: 'datetime', key: 'create_on'}
          ]}
      this.tb.init(setting);
      this.cdr.detectChanges();

  }

  statusUpdate(status) {
    switch(status) {
      case 0:
        return "Completed";
      case 1:
        return "Pending";
      case 9:
        return "Canceled"
    }
  }

  sum(key: string) {
    return this.items.reduce((acc:any, item:any) => acc + parseFloat(item[key] ?? 0), 0);
  }

}
